import { indexTree } from "app/pages/sales-intelligence/utils/taxonomy-tree/tree";

import type { IndustryTaxonomyDto, IndustryTaxonomyIndex } from "../types/taxonomy";

/**
 * Binds the generic tree to the industry taxonomy's wire shape. The algebra operating on the index is
 * imported from `utils/taxonomy-tree` directly: it is generic, so `IndustryNodeId` flows through inference.
 */
export const indexTaxonomy = (dto: IndustryTaxonomyDto): IndustryTaxonomyIndex => indexTree(dto.industries);
